import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const DateOrNotification = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: center;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N400
      : props.theme.atlas.semantic.color.outline.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const MessageInputBox = styled.textarea`
  height: 114px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  resize: vertical;
  border-radius: 5px;
  border-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N400
      : props.theme.atlas.semantic.color.outline.default};
  padding: 8px 16px;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
  }
  &:focus {
    outline: none;
  }
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const MessagesListContainer = styled.div<{ removePadding?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  ${(props) => (props.removePadding ? 'padding: 0;' : 'padding: 0 20px;')}
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow-y: hidden;
  border-radius: 8px;
  height: 100%;
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.typography.fontFamily
      : props.theme.atlas.typography.semantic.bodySmall.fontFamily};
`;

export const MessageInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 20px;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`;

export const MessageAndCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 28px;
  align-items: center;
`;

export const MessageBox = styled.div<{
  isReporter: boolean;
  sameAuthor: boolean;
}>`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-self: ${(props) => (props.isReporter ? 'flex-start' : 'flex-end')};
  margin: 0 0 ${(props) => (props.sameAuthor ? '0px' : '20px')} 0;
`;

export const Minute = styled.div<{ isReporter: boolean }>`
  align-self: ${(props) => (props.isReporter ? 'flex-start' : 'flex-end')};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  padding: 0 20px 30px 20px;
  justify-content: center;
  width: 100%;
`;

export const ModalDescription = styled.section`
  margin: 0;
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  p:last-child {
    margin-bottom: 0;
  }
`;

export const ModalDescriptionBold = styled.span`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  font-weight: 600;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;
